import * as React from "react";
import { action } from "mobx";
import { observer, inject } from "mobx-react";
import { hashHistory } from "react-router";
import SeekerStore from "../../../stores/seekerStore";
import { OpportunitySummary } from "../../../models/opportunity";
import { IOpDetailLocalization, IFilterLocalization, ILocalization } from "../../../models/localization";
import { FilterDisplay } from "../../../models/filteroption";
import { Grid, Row, Col } from "react-flexbox-grid";
import Busy from "../../widgets/busy";
import OpportunitySummaryCard from "../opSummary";
import TextField from "material-ui/TextField";
import Button from "material-ui/Button";
import List, { ListItem, ListItemText } from "material-ui/List";
import IconButton from 'material-ui/IconButton';
import Radio, { RadioGroup } from "material-ui/Radio";
import { FormControlLabel } from "material-ui/Form";
import Checkbox from "material-ui/Checkbox";
import { sort } from "../../../utils/data";
import Drawer from "material-ui/Drawer";
import Search from "material-ui-icons/Search";
import ExpansionPanel, {
  ExpansionPanelSummary,
  ExpansionPanelDetails,
} from 'material-ui/ExpansionPanel';
import Paper from "material-ui/Paper";
import { ScreenMode, BusyEvent } from "../../../models/enums";
import Typography from 'material-ui/Typography';
import ExpandMoreIcon from 'material-ui-icons/ExpandMore';
import * as s from "./filteredOps.css";

const noPadding: any = {
  padding: 0,
}

@observer
export class FilterPanel extends React.Component<{ store: SeekerStore }, {}> {
  checked: any;
  constructor(props: any) {
    super(props);
    this.checked = { color: "#5B6770" };
  }
  search = (): void => {
    this.props.store.opportunityStore.getFilteredResults();
    this.props.store.opportunityStore.setShowFilterControls(false);
  }
  clear = (): void => {
    this.props.store.opportunityStore.clearSearch();   
  }
  close = (): void => {
    this.props.store.opportunityStore.setShowFilterControls(false);
  }
  renderOrgSelection = (filterLocal: IFilterLocalization): JSX.Element => {
    const items: JSX.Element[] = [];
    sort(this.props.store.opportunityStore.filteredOrgs, "label").map((fd: FilterDisplay, i: number): void => {
      items.push(<ListItem key={i} style={noPadding}>
        <Checkbox checked={fd.checked} style={this.checked} tabIndex={-1} disableRipple onChange={(e, chk) => this.props.store.opportunityStore.setFilterOrg(fd.value, chk)} />
        <ListItemText primary={fd.label} />
      </ListItem>);
    });
    if (items.length <= 1) {
      return null;
    }
    return <List>{items}</List>;
  }
  renderCatSelection = (filterLocal: IFilterLocalization): JSX.Element => {
    const items: JSX.Element[] = [];
    sort(this.props.store.opportunityStore.filteredCategories, "label").map((fd: FilterDisplay, i: number): void => {
      items.push(<ListItem key={i} style={noPadding}>
        <Checkbox checked={fd.checked} style={this.checked} tabIndex={-1} disableRipple onChange={(e, chk) => this.props.store.opportunityStore.setFilterCategory(fd.value, chk)} />
        <ListItemText primary={fd.label} />
      </ListItem>);
    });
    if (items.length <= 1) {
      return null;
    }
    return <List>{items}</List>;
  }
  renderLevelSelection = (filterLocal: IFilterLocalization): JSX.Element => {
    const checked: any = { color: "#5B6770" };

    const items: JSX.Element[] = [];
    this.props.store.opportunityStore.filteredLevels.map((fd: FilterDisplay, i: number): void => {
      items.push(<ListItem key={i} style={noPadding}>
        <Checkbox checked={fd.checked} style={checked} tabIndex={-1} disableRipple onChange={(e, chk) => this.props.store.opportunityStore.setFilterLevel(fd.value, chk)} />
        <ListItemText primary={fd.label} />
      </ListItem>);
    });
    if (items.length === 0) {
      return null;
    }
    return <List>{items}</List>;
  }
  renderEmploymentTypeSelection = (filterLocal: IFilterLocalization): JSX.Element => {
    const checked: any = { color: "#5B6770" };
    const items: JSX.Element[] = [];
    this.props.store.opportunityStore.filteredEmploymentType.map((fd: FilterDisplay, i: number): void => {
      items.push(<ListItem key={i} style={noPadding}>
        <Checkbox checked={fd.checked} style={checked} tabIndex={-1} disableRipple onChange={(e, chk) => this.props.store.opportunityStore.setFilterEmploymentLevel(fd.value, chk)} />
        <ListItemText primary={fd.label} />
      </ListItem>);
    });
    if (items.length === 0) {
      return null;
    }
    return <List>{items}</List>;
  }


  renderCanApply = (filterLocal: IFilterLocalization): JSX.Element => {
    const radio: any = { fontSize: "16px" };
    return (<RadioGroup aria-label="Status" name="status" value={this.props.store.opportunityStore.filterRules.canApply ? "Y" : "N"}
      onChange={(e, v) => this.props.store.opportunityStore.setFilterCanApply(v === "Y")}>
      <FormControlLabel value="N" control={<Radio style={this.checked} />} label={<p>{filterLocal.statusAll}</p>} />
      <FormControlLabel value="Y" control={<Radio style={this.checked} />} label={<p>{filterLocal.statusOpen}</p>} />
    </RadioGroup>);
  }
  renderDistance = (filterLocal: IFilterLocalization): JSX.Element => {
    const radio: any = { fontSize: "16px" };
    return (<div>
      <RadioGroup aria-label={filterLocal.distanceHeader} name={filterLocal.distanceHeader} value={this.props.store.opportunityStore.filterRules.distance.toString()}
        onChange={(e, v) => this.props.store.opportunityStore.setFilterMinDistance(parseInt(v, 10))}>
        <FormControlLabel value="0" control={<Radio style={this.checked} />} label={<p>{filterLocal.distanceUnlimited}</p>} />
        <FormControlLabel value="5" control={<Radio style={this.checked} />} label={<p>{filterLocal.distance5Mi}</p>}  />
        <FormControlLabel value="10" control={<Radio style={this.checked} />} label={<p>{filterLocal.distance10Mi}</p>}  />
        <FormControlLabel value="30" control={<Radio style={this.checked} />} label={<p>{filterLocal.distance30Mi}</p>}  />
        <FormControlLabel value="50" control={<Radio style={this.checked} />} label={<p>{filterLocal.distance50Mi}</p>}  />
      </RadioGroup>
      <TextField value={this.props.store.opportunityStore.filterRules.zip} placeholder={filterLocal.zipcode} label={filterLocal.zipcode} onChange={(e) => this.props.store.opportunityStore.setFilterZipcode(e.target.value)} />
    </div>);
  }
  renderMinAge = (filterLocal: IFilterLocalization): JSX.Element => {
    const ages: JSX.Element[] = [];
    this.props.store.opportunityStore.filterAges.map((age: number): void => {
      ages.push(<FormControlLabel key={age} value={age.toString()} control={<Radio style={this.checked} />} label={<p>{age}</p>} />);
    });
    return (
      <RadioGroup aria-label="min-age" name="minAge" value={this.props.store.opportunityStore.filterRules.minAge.toString()}
        onChange={(e, v) => this.props.store.opportunityStore.setFilterMinAge(parseInt(v, 10))}>
        <FormControlLabel value="999" control={<Radio style={this.checked} />} label={<p>{filterLocal.ageUnlimited}</p>} />
        {ages}
      </RadioGroup>);
  }
  renderMinEd = (filterLocal: IFilterLocalization): JSX.Element => {
    const items: JSX.Element[] = [];
    this.props.store.opportunityStore.filterdEdLevels.map((fd: FilterDisplay, i: number): void => {
      items.push(<FormControlLabel key={i} value={fd.value.toString()} label={<p>{fd.label}</p>} control={<Radio style={this.checked} />} />);
    });
    if (items.length === 0) {
      return null;
    }
    return (
      <RadioGroup aria-label="Min-education" name="minEd" value={this.props.store.opportunityStore.filterRules.minEd.toString()}
        onChange={(e, v) => this.props.store.opportunityStore.setFilterMinEdLevel(parseInt(v, 10))}>
        {items}</RadioGroup>);
  }
  renderPositionTitle = (fl:IFilterLocalization): JSX.Element  => {
    return <TextField fullWidth value={this.props.store.opportunityStore.filterRules.position} onChange={(e) => this.props.store.opportunityStore.setFilterPosition(e.target.value)} />
  }
  renderExpansion = (filterLocal: IFilterLocalization, label: string, bodyFunc: (fl: IFilterLocalization) => JSX.Element): JSX.Element => {
    const items: JSX.Element = bodyFunc(filterLocal);
    if (!items) { return null; }
    return (<ExpansionPanel className={s.panel} >
      <ExpansionPanelSummary expandIcon={<ExpandMoreIcon color="secondary" />}>
        <Typography>{label}</Typography>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails>
        {bodyFunc(filterLocal)}
      </ExpansionPanelDetails>
    </ExpansionPanel>);
  }
  renderFilterControls(filterLocal:IFilterLocalization): JSX.Element {
    return (
      <div>
        {this.renderExpansion(filterLocal, filterLocal.positionTitle, this.renderPositionTitle)}
        {this.renderExpansion(filterLocal, filterLocal.statusHeader, this.renderCanApply)}
        {this.renderExpansion(filterLocal, filterLocal.orgHeader, this.renderOrgSelection)}
        {this.renderExpansion(filterLocal, filterLocal.catHeader, this.renderCatSelection)}
        {this.renderExpansion(filterLocal, filterLocal.levelHeader, this.renderLevelSelection)}
        {this.renderExpansion(filterLocal, filterLocal.empTypeHeader, this.renderEmploymentTypeSelection)}
        {this.renderExpansion(filterLocal, filterLocal.distanceHeader, this.renderDistance)}
        {this.props.store.opportunityStore.filterAges.length > 0 && this.renderExpansion(filterLocal, filterLocal.ageHeader, this.renderMinAge)}
        {this.renderExpansion(filterLocal, filterLocal.edHeader, this.renderMinEd)}
      </div>);
  }
  render(): JSX.Element {
    const filterLocal: IFilterLocalization = this.props.store.localization.fields.filterComponent;
    const local: ILocalization = this.props.store.localization.fields;
    const btnStyle: any = { marginBottom: "50px" };
    return <Drawer anchor="right" open={this.props.store.opportunityStore.showFilterControls} onClose={this.close}>
      {this.renderFilterControls(filterLocal)}
      <Row className={s.drawerBtnRow}>
        <Col xs={12} className={s.drawerBtnCol}><Button raised color="secondary" className={s.drawerBtn} onClick={this.search}>{filterLocal.search}</Button></Col>
        <Col xs={12} className={s.drawerBtnCol}><Button raised color="secondary" className={s.drawerBtn} onClick={this.clear}>{filterLocal.clear}</Button></Col>
        <Col xs={12} className={s.drawerBtnCol}><Button raised color="secondary" className={s.drawerBtn} style={btnStyle} onClick={this.close}>{local.close}</Button></Col>
      </Row>
      </Drawer>;
  }
}

@inject("store") @observer
export default class FilteredOps extends React.Component<{ store: SeekerStore }, {}> { 
  constructor(props: any) {
    super(props);  
  }
  componentWillMount(): void {
    this.props.store.opportunityStore.getFilteredMeta();
  }

  renderFilteredOps(): JSX.Element {

    const local: ILocalization = this.props.store.localization.fields;
    let cards: JSX.Element[] = [];
    if (this.props.store.viewState.isBusy(BusyEvent.SearchingOpportunities)) {
      return <Busy show={true} size="lg" center={true} />;
    } else if (this.props.store.opportunityStore.filterResults.length === 0 && this.props.store.opportunityStore.searchTriggered) {
      return <Grid className={s.filterGrid} fluid><Row><h6 className={s.noMatch}>{local.noMatches}</h6></Row></Grid>
    } else if (!this.props.store.opportunityStore.searchTriggered) {
      return null;
    } else {
      let catName2: string = "undefined";
      sort(this.props.store.opportunityStore.filterResults, "category").map((os: OpportunitySummary, i: number): void => {
        const catName1: string = os.category;
          if (catName1.match(catName2) === null) {
            //new category
            cards.push(<Col xs={12}><h6 className={s.catName}>{os.category}</h6></Col>)
          }
          cards.push(<OpportunitySummaryCard key={i} store={this.props.store} op={os} />);
          catName2 = catName1;
      });
      return <Grid className={s.filterGrid} fluid><Row>{cards}</Row></Grid>
    }
  }

  search = (): void => {
    //save input
    const input: string = this.props.store.opportunityStore.filterRules.position;
    //resets all search inputs from filter search
    this.props.store.opportunityStore.clearSearch();
    this.props.store.opportunityStore.setFilterPosition(input);
    this.props.store.opportunityStore.getFilteredResults();
    this.props.store.opportunityStore.setShowFilterControls(false);
  }

  @action showAll = (): void => {
    this.props.store.opportunityStore.clearSearch();
    this.props.store.opportunityStore.getFilteredResults();
    this.props.store.opportunityStore.setShowFilterControls(false);
  }

  clear = (): void => {
    this.props.store.opportunityStore.clearSearch();   
  }

  renderOpenSearch(): JSX.Element {
    const mode: ScreenMode = this.props.store.viewState.screenMode;
    const tablet = mode === ScreenMode.Tablet;
    
    const greenBtn: any = {
      backgroundColor: "#3CBA54",
    }
    const blueBtn: any = {
      backgroundColor: "#0072CE",
    }
    const redBtn: any = {
      backgroundColor: "#EA7600",
    }

    return (<Row className={s.searchRow}>
        <Col xs={12}>
        <p className={s.blueHeader}>{this.props.store.localization.fields.filterComponent.searchHint}</p>
        </Col>
        <Col xs={9} sm={5} xl={4} className={ tablet? s.openSearchCol : null}>
        <TextField fullWidth value={this.props.store.opportunityStore.filterRules.position} onChange={(e) => this.props.store.opportunityStore.setFilterPosition(e.target.value)} label={this.props.store.localization.fields.filterComponent.positionTitle} />
        </Col>
        {mode === ScreenMode.Mobile && <Col xs={3} className={s.buttonColMobile}>
          <IconButton color="primary" style={blueBtn} className={s.ssSearchButtons} aria-label="search-icon-btn" onClick={this.search}>
          <Search />
        </IconButton>
        </Col>}
        {mode !== ScreenMode.Mobile && <Col xs={3} sm={3} md={3} lg={2} className={s.buttonCol}>
          <Button raised color="secondary" className={s.ssSearchButtons} onClick={this.search}>
          {this.props.store.localization.fields.filterComponent.search}&nbsp;
          <Search />
          </Button>
        </Col>}
        <Col xs={12} sm={2} md={2} xl={3} className={s.buttonCol} >
          <Button raised color="secondary" style={redBtn} className={s.ssSearchButtons} onClick={this.showAll}> {this.props.store.localization.fields.filterComponent.showAll}</Button>
        </Col>
        <Col xs={12} sm={2} md={2} xl={3}className={s.buttonCol} >
        <Button raised color="secondary" style={greenBtn} className={s.ssSearchButtons} onClick={() => this.props.store.opportunityStore.setShowFilterControls(true)}> {this.props.store.localization.fields.filterComponent.search2}</Button>
        </Col>
    </Row>)
  }
  render(): JSX.Element {

    const paper: any = { backgroundColor: "#F6F8F8" };
    return (<Paper elevation={4} className={s.paper} style={paper}><div className={s.container}><h4 className={s.featureTitle}>{this.props.store.localization.fields.filterComponent.search}</h4>
      <Busy show={this.props.store.opportunityStore.searching} size="sm" />
      {this.renderOpenSearch()}
      {this.props.store.opportunityStore.filterResults.length >= 1 && <Row className={s.clearBtnRow}><Button color="secondary" onClick={this.clear}>{this.props.store.localization.fields.filterComponent.clear}</Button></Row>}
      <FilterPanel store={this.props.store} />
      </div>
      {this.renderFilteredOps()}
      </Paper>);
  }
}


// WEBPACK FOOTER //
// ./src/components/opportunity/filteredOps/index.tsx